module.exports = __webpack_public_path__ + "static/media/Shop_Purple_TriangleDivider@3x.dce6de0d.png";